var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockClosedDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 20C14.0135 20.0037 17.2698 16.7535 17.2736 12.7404C17.2756 10.5304 16.2718 8.43955 14.5459 7.05913V4.5455C14.5459 2.03505 12.5108 0 10.0004 0C7.49003 0 5.45501 2.03505 5.45501 4.54546V7.05909C2.32105 9.56572 1.8125 14.1383 4.31912 17.2723C5.69954 18.9982 7.79039 20.002 10.0004 20ZM7.27318 4.54546C7.27318 3.03923 8.49421 1.81817 10.0005 1.81817C11.5067 1.81817 12.7278 3.03919 12.7278 4.54546V5.99002C10.9796 5.27613 9.02134 5.27613 7.27322 5.99002V4.54546H7.27318ZM10.0004 7.27271C13.0129 7.27271 15.455 9.7148 15.455 12.7273C15.455 15.7397 13.0129 18.1818 10.0004 18.1818C6.98798 18.1818 4.54589 15.7397 4.54589 12.7273C4.54892 9.71606 6.98924 7.27574 10.0004 7.27271Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09104 13.3845V15.4545C9.09104 15.9566 9.49804 16.3636 10.0001 16.3636C10.5022 16.3636 10.9092 15.9566 10.9092 15.4545V13.3845C11.7788 12.8824 12.0768 11.7705 11.5747 10.9009C11.0726 10.0312 9.96068 9.73327 9.09104 10.2354C8.22141 10.7374 7.92345 11.8494 8.42554 12.719C8.58513 12.9954 8.81466 13.225 9.09104 13.3845Z",
    fill: "#7A297F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#7A297F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosedDark);
export default __webpack_public_path__ + "static/media/lock-closed-dark.f32a38c86482a31a25a97b6d30133fe0.svg";
export { ForwardRef as ReactComponent };